// removed by extract-text-webpack-plugin
module.exports = {"similarInventoryRecords":"_26lcX","header":"hHI6V","similarInventoryRecordsListElement":"btJ1F","similarInventoryRecordsListElementPhoto":"ZX6OT","listWrapper":"_3qSmL","listScrollContainer":"_206f5","list":"GWCwW","separator":"_3rFHe"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/SimilarProductsSection/index.sass
// module id = 1508
// module chunks = 1